
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "updateAreaOnScenario",
      resolverType: "mutation",
      routePath: "/updateAreaOnScenario",
      httpMethod: "POST",
    });
  